// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"79":"c4e7c6c4","172":"2b077eee","213":"19ac67b5","312":"03a317b1"}[chunkId] + ".js";
};